import React from 'react';
import { Button } from '../ui/Button';
import { trackAddToCart } from '../../utils/metaPixel';
import { ShieldCheckIcon } from 'lucide-react';
export function OfferBlock() {
  return <section id="offer-section" className="py-24 bg-white relative overflow-hidden" data-id="element-139">
      <div className="absolute inset-0 bg-forest-50/50" data-id="element-140"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-141">
        <div className="bg-white rounded-3xl shadow-editorial border border-stone-100 p-8 md:p-16 text-center" data-id="element-142">
          <h2 className="text-3xl md:text-5xl font-serif text-stone-900 mb-6" data-id="element-143">
            Stop guessing and start the flush.
          </h2>

          <p className="text-xl text-stone-600 mb-10 max-w-2xl mx-auto" data-id="element-144">
            Get the full 48-Hour Gut Reset Planner today for the price of a
            single lunch.
          </p>

          <div className="mb-10" data-id="element-145">
            <div className="inline-flex flex-col items-center justify-center p-8 bg-stone-50 rounded-2xl border border-stone-100 w-full max-w-md mx-auto" data-id="element-146">
              <span className="text-stone-500 uppercase tracking-wider text-sm font-semibold mb-2" data-id="element-147">
                Limited-Time Price
              </span>
              <div className="flex items-center justify-center mb-1" data-id="element-148">
                <span className="text-2xl font-medium text-stone-400 line-through" data-id="element-149">
                  $19
                </span>
              </div>
              <div className="flex items-start justify-center" data-id="element-150">
                <span className="text-3xl font-medium text-forest-800 mt-2" data-id="element-151">
                  $
                </span>
                <span className="text-7xl font-serif font-medium text-forest-800" data-id="element-152">
                  6.39
                </span>
              </div>
              <div className="mt-3 inline-flex items-center bg-forest-100 text-forest-800 text-sm font-semibold px-3 py-1 rounded-full" data-id="element-153">
                Save 66%
              </div>
              <p className="text-sm text-stone-500 mt-4" data-id="element-154">
                Instant Digital Access (PDF)
              </p>
            </div>
          </div>

          <Button size="lg" href="https://thedailyedit.it.com/cart/47830899851456:1" onClick={trackAddToCart} className="w-full max-w-md mx-auto text-lg py-5 shadow-xl hover:shadow-2xl" data-id="element-155">
            GET THE 48-HOUR RESET NOW
          </Button>

          <div className="mt-8 flex items-center justify-center text-stone-500 text-sm" data-id="element-156">
            <ShieldCheckIcon className="w-5 h-5 mr-2 text-forest-600" data-id="element-157" />
            <span data-id="element-158">Secure checkout. Instant delivery.</span>
          </div>
        </div>
      </div>
    </section>;
}